import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavDropdown } from 'react-bootstrap';
import { IconBell } from '@tabler/icons-react';

import SeeAllNotifcation from 'pages/notifications/containers/notifications/components/dropdown/SeeAllNotifcation';

import { notificationActions } from 'pages/notifications/containers/notifications/actions';
import NotificationsDropdownListing from './dropdownListing';
import { getSiteNotifications } from 'selectors';

const NotificationDropdown = (props) => {
  const { dropdown_notifications, unread_notification, updateNotificationStatus } = props;

  const handleNotificationStatus = (notification_id, status) => {
    if (status === false) {
      updateNotificationStatus(notification_id, status !== true);
    }
  };

  return (
    <NavDropdown
      title={
        <span className="active">
          <IconBell stroke={1.5} />
          {unread_notification.length > 0 ? <span className="badge">{unread_notification.length}</span> : ''}
        </span>
      }
      align="end"
      id="notification-nav-dropdown"
      className="notifications btn-icon ms-2 ms-xl-3"
      role="button"
      aria-label="Notification Opener"
    >
      {dropdown_notifications.length > 0 ? (
        <Fragment>
          <div className="notification-block">
            <NotificationsDropdownListing
              dropdown_notifications={dropdown_notifications}
              handleNotificationStatus={handleNotificationStatus}
            />
          </div>
          <SeeAllNotifcation />
        </Fragment>
      ) : (
        <div className="no-notification">
          <span>No Notification Available</span>
        </div>
      )}
    </NavDropdown>
  );
};

function mapStateToProps(state) {
  const { dropdown_notifications } = getSiteNotifications(state);
  const unread_notification = dropdown_notifications.filter((notification) => notification.is_read === false);
  return {
    dropdown_notifications,
    unread_notification
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(notificationActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationDropdown);
